import { Dimensions, StyleSheet } from 'react-native';
import { useRem } from '../../hooks/useRem';
import { useStyleVars } from '../../hooks/useStyleVars';
export function useStyle({ kidtoken, scalable, customStyle = {}, }) {
    const getRem = useRem(scalable);
    const { swiperWidth, swiperHeight, borderRadius, indicatorColor, indicatorActiveColor, } = customStyle;
    const customVars = {
        kibt_indicator_control_color: indicatorColor,
        kibt_indicator_control_active_color: indicatorActiveColor,
        kibt_swiper_size_width: swiperWidth,
        kibt_swiper_size_height: swiperHeight,
        kibt_swiper_size_border_radius: borderRadius,
    };
    const defaultVars = {
        kibt_indicator_control_color: '#ffffff', //cs_common_background_placeholder,
        kibt_indicator_control_active_color: '#eeeeee', //cs_common_background_black,
        kibt_swiper_size_width: Dimensions.get('window').width,
        kibt_swiper_size_height: 250,
        kibt_swiper_size_border_radius: 0,
    };
    const vars = useStyleVars({
        defaultVars,
        customVars,
        scalable,
        kidtoken,
    });
    return {
        vars,
        style: StyleSheet.create({
            container: {
                backgroundColor: 'transparent',
                position: 'relative',
                width: vars.kibt_swiper_size_width,
            },
            scrollStyle: {
                position: 'relative',
                // overflow: 'hidden',
                height: vars.kibt_swiper_size_height,
                width: vars.kibt_swiper_size_width,
                borderRadius: vars.kibt_swiper_size_border_radius,
            },
            slideStyle: {
                width: vars.kibt_swiper_size_width,
                height: '100%',
            },
            slideStyleWeb: {
                height: vars.kibt_swiper_size_height,
                overflow: 'hidden',
            },
            wrapperIOS: {
                backgroundColor: 'transparent',
            },
            wrapperAndroid: {
                backgroundColor: 'transparent',
                flex: 1,
            },
            indicatorHorizontalWrapper: {
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                width: '100%',
                position: 'absolute',
                bottom: 0,
                paddingTop: getRem(7),
                paddingBottom: getRem(7),
                zIndex: 1,
            },
            indicatorItem: {
                borderRadius: 45,
                width: getRem(8),
                height: getRem(8),
                backgroundColor: indicatorColor !== null && indicatorColor !== void 0 ? indicatorColor : '#fff',
                marginRight: getRem(8),
                marginLeft: getRem(8),
                opacity: 0.4,
            },
            indicatorActive: {
                opacity: 1,
            },
        }),
    };
}
